import { forwardRef } from 'react';
import { cn } from '../../lib/utils.js';

/**
 * Container component with responsive padding
 */
export const Container = forwardRef(function Container(
  {
    children,
    size = 'default',
    className,
    as: Component = 'div',
    ...props
  },
  ref
) {
  const sizes = {
    default: 'container mx-auto px-4 md:px-8 lg:px-12',
    narrow: 'max-w-3xl mx-auto px-4 md:px-8',
    wide: 'max-w-7xl mx-auto px-4 md:px-6 lg:px-8',
    full: 'w-full px-4 md:px-8 lg:px-12',
  };

  return (
    <Component
      ref={ref}
      className={cn(sizes[size], className)}
      {...props}
    >
      {children}
    </Component>
  );
});

export default Container;
